import _extends from 'babel-runtime/helpers/extends';

import { mapActions, mapState } from 'vuex';
import isMaterialWarehouse from '@/common/is-warehouse';
import PtButton from '@com/pt-components/pt-button/index.vue';
import { PtButtonTheme as _PtButtonTheme, PtButtonType as _PtButtonType } from '@com/pt-components/pt-button/enum';

export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  components: {
    PtButton: PtButton
  },
  data: function data() {
    return {};
  },


  computed: _extends({
    PtButtonTheme: function PtButtonTheme() {
      return _PtButtonTheme;
    },
    PtButtonType: function PtButtonType() {
      return _PtButtonType;
    }
  }, mapState({
    templateState: function templateState(state) {
      return state.creative.template.templateState;
    },
    fontList: function fontList(state) {
      return state.config.fontList;
    },
    languages: function languages(state) {
      return state.creative.template.templateConfig.json_config.i18n.languages || {};
    }
  })),

  methods: _extends({}, mapActions({
    saveTemplateInfo: 'creative/template/saveTemplateInfo'
  }), {
    handleSave: function handleSave() {
      this.saveTemplateInfo();
    },


    isMaterialWarehouse: isMaterialWarehouse
  })
};